import { Typography, useMediaQuery } from '@mui/material';

import { device } from 'src/constants/muiSize';

import { Base02TextContainer, Container, DescriptionContainer, MediaContainer, MediaItemButton } from './styled';

import { ReactComponent as Cosmostation24Icon } from 'src/assets/svg/Cosmostation24.svg';
import { ReactComponent as Github24Icon } from 'src/assets/svg/Github24.svg';
import { ReactComponent as Medium24Icon } from 'src/assets/svg/Medium.svg';
import { ReactComponent as MintscanIcon } from 'src/assets/svg/Mintscan.svg';
import { ReactComponent as Telegram24Icon } from 'src/assets/svg/Telegram.svg';
import { ReactComponent as Twitter24Icon } from 'src/assets/svg/Twitter24.svg';
import { ReactComponent as Youtube24Icon } from 'src/assets/svg/Youtube.svg';

export default function Footer() {
  const isLaptop = useMediaQuery(device.minLaptop);

  const mediaItemList = [
    {
      icon: Cosmostation24Icon,
      name: 'Cosmostation',
      link: 'https://www.cosmostation.io/',
    },
    {
      icon: Twitter24Icon,
      name: 'Twitter',
      link: 'https://twitter.com/CosmostationVD',
    },
    {
      icon: Telegram24Icon,

      name: 'Telegram',
      link: 'https://t.me/cosmostation',
    },
    {
      icon: Medium24Icon,

      name: 'Medium',
      link: 'https://medium.com/cosmostation',
    },
    {
      icon: Github24Icon,

      name: 'Github',
      link: 'https://github.com/cosmostation',
    },
    {
      icon: Youtube24Icon,
      name: 'Youtube',
      link: 'https://www.youtube.com/@cosmostationio',
    },
  ];

  return (
    <Container>
      <MintscanIcon />
      <Base02TextContainer>
        <Typography variant={isLaptop ? 'h8' : 'h11'}>Powered by COSMOSTATION</Typography>
      </Base02TextContainer>

      <DescriptionContainer>
        <Typography variant={isLaptop ? 'h9' : 'h11'}>
          {`Cosmostation provides partner networks with protocol infrastructure legos vital to scaling\nand onboarding users. Supercharge your protocol with smart crypto infrastructure.`}
        </Typography>
      </DescriptionContainer>

      <MediaContainer>
        {mediaItemList.map((item) => (
          <MediaItemButton
            key={item.name}
            onClick={() => {
              window.open(item.link);
            }}
          >
            <item.icon />
            <Typography variant="h11">{item.name}</Typography>
          </MediaItemButton>
        ))}
      </MediaContainer>
    </Container>
  );
}
